export const API_URL = process.env.REACT_APP_API_URL as string;
export const JWT_SECRET = '12345';
export const API_MOCKING = JSON.parse(
  process.env.REACT_APP_API_MOCKING as string,
);
export const WEB_URL = process.env.REACT_APP_WEB_URL as string;
